import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as FA from '@fortawesome/free-solid-svg-icons';

// Assets
import '../Assets/CoursesListInstructor.sass';

// Components
import Navbar from 'Screens/Layout/Common/Components/Navbar';
import InstructorData from './InstructorData';

export enum FormType {
    NONE = 0,
    ADD_COURSE = 1,
    IMPORT_COURSE = 2
};

interface IProps {
    toggleForm: (FormType) => void;
    form: any;
    courses: any;
};

const CoursesListInstructor = (props: IProps) => (
    <React.Fragment>
        <Navbar navbarClass='navbar-light' />
        <div className="bd-content-header">
            <div className="container">
                <div className="row">
                    <div className="col-md-8 bd-content-title"> My Dashboard</div>
                    <div className='col-md-4 offering-form-buttons'>
                        <button
                            className='add-course-button ml-auto'
                            type='button'
                            data-toggle='modal'
                            data-target='#course-enrolment-form'
                        // onClick={() => props.toggleForm(FormType.ADD_COURSE)}>
                        >
                            <FontAwesomeIcon className='plus-icon' icon={FA.faPlus} />Add Course
                        </button>
                    </div>
                    {props.form}
                </div>
            </div>
        </div>
        <div className='container'>
            {/* <InstructorData /> */}

            <div className='instructor-courses-list'>{props.courses}</div>
        </div>
    </React.Fragment>
);

export default CoursesListInstructor;
